export interface SavedPresetDTO {
  id: string;
  name: string;
  viewType: PresetViewType;
  preset: unknown;
  isDefault: boolean;
  isFavorite: boolean;
  updatedAt: string;
}

export enum PresetViewType {
  cohortMarketingPerformance = 'cohortMarketingPerformance',
  calendarInsights = 'calendarInsights',
  cohortChart = 'cohortChart',
  calendarChart = 'calendarChart',
  cohortRetention = 'cohortRetention',
  cohortScanner = 'cohortScanner',
  roiBreakdown = 'roiBreakdown',
}
